module.exports = __webpack_public_path__ + "img/Group383.76548b8.svg";